export const formatPrice = (price, includeFractions = false) => {
  return Number(price || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: includeFractions ? 2 : 0,
  }).replace(/^(\D+)/, '$1 ');
};
